import { RESOURCES } from "../../actions/actionConstants.js";
import { buildAtId } from "../../../utils/utils.js";

// type - can be one of RESOURCE_KEYS or AT_TYPES
export const getResource = (id, type, charge, usage, measurements) => {
  const atId = buildAtId({ id, type });
  return {
    type: RESOURCES.GET,
    payload: { atId, type, charge, usage, measurements }
  };
};

// type - can be one of RESOURCE_KEYS or AT_TYPES
export const getResourceByAtId = (atId, type, charge, usage, measurements) => {
  return {
    type: RESOURCES.GET,
    payload: { atId, type, charge, usage, measurements }
  };
};

export default {};
